module.exports = __webpack_public_path__ + "img/IMG_4215_L_WoodMatted.2736cd4a.jpg";